/**
 * @generated SignedSource<<f1ab959da50c43c2b3a46c68d2614acf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventNewContent_user$data = {
  readonly editingGuilds: {
    readonly nodes: ReadonlyArray<{
      readonly guild: {
        readonly defaultTimeZone: string | null | undefined;
        readonly name: string;
        readonly rowId: string;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly firstName: string;
  readonly lastName: string;
  readonly organizingGuilds: {
    readonly nodes: ReadonlyArray<{
      readonly guild: {
        readonly defaultTimeZone: string | null | undefined;
        readonly name: string;
        readonly rowId: string;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly rowId: string;
  readonly slugId: string;
  readonly " $fragmentType": "EventNewContent_user";
};
export type EventNewContent_user$key = {
  readonly " $data"?: EventNewContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventNewContent_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembership",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Guild",
        "kind": "LinkedField",
        "name": "guild",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultTimeZone",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventNewContent_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": "organizingGuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "ORGANIZER"
          }
        },
        (v1/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:10)"
    },
    {
      "alias": "editingGuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "EDITOR"
          }
        },
        (v1/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:10)"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "239dffa7fb97c578fb1aa17eb1611d4d";

export default node;
